// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__U7QZd","header":"Details_header__3SLXe","headerText":"Details_headerText__391VP"};